import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from "@material-ui/core"
import { Print } from "@material-ui/icons"
import useAppStore from "../../../stores/AppStore.ts"

const DialogDetalhesDaMesa = ({ openDialog, mesaDialog, handleToggleOpenDialog, classes }) => {
    const mandarImprimir = useAppStore(s => s.mandarImprimir)

    return (
        <Dialog open={openDialog} onClose={handleToggleOpenDialog} fullWidth>
            <DialogTitle>
                Detalhes da mesa:{" "}
                <span style={{ fontWeight: "lighter" }}>{mesaDialog.numeroMesa}</span>
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.subtituloDialog}>Produto(s):</Typography>
                {mesaDialog?.pedidos?.map(pedido =>
                    pedido?.itens?.map((item, i) => {
                        return (
                            <div key={i}>
                                <Grid container>
                                    <Grid item xs={8} sm={8} md={9}>
                                        <Typography>
                                            {item.quantidade}x {item.produto.nome}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={3}>
                                        <Typography>
                                            R$
                                            {item?.valorProdutoHistorico
                                                ?.toFixed(2)
                                                .replace(".", ",")}
                                        </Typography>
                                    </Grid>
                                    {item?.itensOpcaoProduto?.map(item => {
                                        return (
                                            <>
                                                <Grid item xs={8} sm={8} md={9}>
                                                    <Typography style={{ marginLeft: "1.5em" }}>
                                                        {item.quantidade}x {item.nome}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={3}>
                                                    <Typography>
                                                        R$
                                                        {item?.valorHistorico
                                                            ?.toFixed(2)
                                                            .replace(".", ",")}
                                                    </Typography>
                                                </Grid>
                                            </>
                                        )
                                    })}
                                </Grid>
                                <hr />
                            </div>
                        )
                    })
                )}
                <Grid container>
                    <Grid item xs={8} sm={8} md={9}>
                        <Typography style={{ fontWeight: "bold" }}>Total:</Typography>
                    </Grid>
                    <Grid item xs={4} sm={4} md={3}>
                        <Typography>
                            R$
                            {mesaDialog?.pagamentos
                                ?.reduce((total, pagamento) => total + pagamento.valor, 0)
                                ?.toFixed(2)
                                ?.replace(".", ",")}
                        </Typography>
                    </Grid>
                </Grid>
                <hr />
                <Typography className={classes.subtituloDialog} style={{ marginTop: "1em" }}>
                    Forma(s) de Pagamento:
                </Typography>
                {mesaDialog?.pagamentos?.map((pagamento, i) => (
                    <div key={i}>
                        <Grid container>
                            <Grid item xs={8} sm={8} md={9}>
                                <Typography>{pagamento.formaPagamento.descricao}</Typography>
                            </Grid>
                            <Grid item xs={4} sm={4} md={3}>
                                <Typography>
                                    R${pagamento?.valor?.toFixed(2).replace(".", ",")}
                                </Typography>
                            </Grid>
                        </Grid>
                        <hr />
                    </div>
                ))}
            </DialogContent>
            <DialogActions>
                <Button
                    className={classes.botaoImprimir}
                    onClick={() =>
                        mandarImprimir({ texto: mesaDialog?.impressao, numeroDaImpressora: 1 })
                    }
                >
                    <Typography>
                        <Print /> Imprimir
                    </Typography>
                </Button>
                <Button className={classes.botaoFecharDialog} onClick={handleToggleOpenDialog}>
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogDetalhesDaMesa
